// src/utils/date.js
import { plural } from "./pluralize";

export const pad2 = (n) => String(n).padStart(2, "0");
export const iso = (d) =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const addMonths = (d, n) => {
  const x = new Date(d);
  const day = x.getDate();
  x.setDate(1);
  x.setMonth(x.getMonth() + n);
  const lastDay = new Date(x.getFullYear(), x.getMonth() + 1, 0).getDate();
  x.setDate(Math.min(day, lastDay));
  return x;
};

export const addYears = (d, n) => {
  const x = new Date(d);
  x.setFullYear(x.getFullYear() + n);
  return x;
};
export const parseISO = (s) => {
  const [y, m, d] = String(s).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const TODAY = iso(new Date());
export const todayIso = () => iso(new Date());

export const daysDiff = (a, b) =>
  Math.round((parseISO(b) - parseISO(a)) / 86400000);

export const humanizeDeadline = (deadlineIso) => {
  if (!deadlineIso) return "";
  const diff = daysDiff(TODAY, deadlineIso);
  if (diff === 0) return "сегодня";
  if (diff > 0) return `через ${diff} ${plural(diff, "день", "дня", "дней")}`;
  const late = -diff;
  return `просрочено на ${late} ${plural(late, "день", "дня", "дней")}`;
};

export const MS_SHORT = [
  "янв",
  "фев",
  "мар",
  "апр",
  "мая",
  "июн",
  "июл",
  "авг",
  "сен",
  "окт",
  "ноя",
  "дек",
];
export const MS_FULL = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const MONTH_NAMES = MS_FULL;
export const MONTH_NAMES_SHORT = MS_SHORT;
export const WEEKDAY_LABELS = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];

export const fmtD = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "-";
  return `${d.getDate()} ${MS_SHORT[d.getMonth()]}`;
};
export const fmtDMY = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "-";
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
};
export const fmtDT = (ts) => {
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "-";
  return `${fmtDMY(iso(d))} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};
export const uid = () => Math.random().toString(36).slice(2, 10);
export const initials = (f, l) => `${(f || "?")[0]}${(l || "?")[0]}`;
